<template>
    <div>
        <el-input
            ref="main"
            v-model="address"
            :clearable="disabled"
            :disabled="disabled"
            :placeholder="placeholder"
            @clear="handleClear"
            @focus="handleShow"
        />
        <p v-if="value">
            纬度：{{ value.latitude }}&nbsp;&nbsp; 经度：{{ value.longitude }}
        </p>
        <el-dialog
            :visible.sync="box"
            append-to-body
            title="选择位置"
            width="80%"
            @close="handleClose"
        >
            <div v-if="box">
            <div class="input-box" style="position: relative">
                <el-input
                id="map__input"
                v-model="address"
                class="input-map-content-input"
                :readonly="disabled"
                clearable
                placeholder="输入关键字选取地点"
                @clear="clear"
                @keyup.enter.native="handleSearch"
                @input="querySearch"
                >
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="handleSearch"
                ></el-button>
                </el-input>
                <div class="Suggest_suggests__E1VWl" v-show="visibleSuggest">
                    <span v-if="fetching" size="small">加载中<i class="el-icon-loading"></i></span>
                    <template v-else>
                        <div
                        class="Suggest_liItem__UATyw"
                        v-for="(item, index) in suggestArr"
                        :key="index"
                        @click="handleSelectSug(item.name)"
                        >
                            <span
                                role="img"
                                aria-label="search"
                                class="anticon anticon-search"
                            >
                                <i class="el-icon-search"></i>
                            </span>
                            <span class="Suggest_name__d+lUa" v-html="item.nameStr"></span>
                            <span class="Suggest_address__e0ul6">{{ item.address }}</span>
                        </div>
                    </template>
                </div>
                <div
                    id="map__container"
                    class="input-map-content-container"
                    tabindex="0"
                />
                <div
                    id="map__result"
                    class="input-map-content-result"
                    v-show="visibleResult"
                >
                    <div
                        class="poibox"
                        v-for="(item, index) in resultArr"
                        :key="index"
                        @click="showPosition(item)"
                    >
                        <h3 class="poi-title">
                            <i class="el-icon-location-outline" style="color: #1890FF"></i>
                            <span class="poi-name amap-ellipsis">{{ item.name }}</span>
                        </h3>
                        <div class="poi-info">
                            <p class="poi-addr amap-ellipsis">地址：{{ item.address }}</p>
                            <p class="poi-tel amap-ellipsis">电话：{{ item.phone }}</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!disabled" type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
const _createScript = url => {
    const jsapi = document.createElement('script')
    jsapi.charset = 'utf-8'
    jsapi.src = url
    document.head.appendChild(jsapi)
}
export const MapLoader = () => {
    return new Promise(resolve => {
        if (!window.T) { // 判断window下有没有T对象，再判断是否引入cdn地图
            _createScript('http://api.tianditu.gov.cn/api?v=4.0&tk=458b757eee944290645a95d7c34b7b90')
             // 创建定时器 当T有值的时候 清除定时器 并resolve
             const interval = setInterval(() => {
                if (window.T) {
                    clearInterval(interval)
                    resolve(window.T)
                }
            }, 50)
        } else resolve(window.T)
    })
}
MapLoader();
export default {
    name: "InputMap",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default: () => {},
        },
        placeholder: {
            type: String,
            default: "请选择",
        },
    },
    data() {
        return {
            address: "",
            poi: {},
            text: "",
            marker: null,
            map: null,
            geocode: null,
            box: false,
            fetching: false,
            isSelect: false,
            localsearch: null,
            resultArr: [],
            suggestArr: [],
            visibleSuggest: false,
            visibleResult: false,
            bounds: null,
        }
    },
    watch: {
        poi(val) {
            this.address = val.address;
        },
        value: {
            handler: function (val) {
                if (!val) {
                    this.poi = {};
                } else {
                    this.address = val.address;
                }
            },
            immediate: true,
            deep: true
        },
        // address(val) {
        //     if (!val) this.clear();
        // },
        text(val) {
            if (val) {
                this.poi = { ...val };
                this.address = val.address;
            }
        },
        box: {
            handler() {
                if (this.box) {
                    this.$nextTick(() => this.init())
                }
            }
        }
    },
    methods: {
        clear() {
            this.poi = {};
            this.visibleResult = false;
            this.map.clearOverLays();
        },
        handleSubmit() {
            this.setVal();
            this.$emit("input", this.text);
            this.visibleResult = false;
            this.box = false;
        },
        handleClear() {
            this.text = {};
            this.poi = {};
        },
        setVal() {
            const { address, formattedAddress, longitude, latitude, county } =
                this.poi;
            this.text = {
                address: address || formattedAddress,
                longitude,
                latitude,
                county,
            };
        },
        handleShow() {
            this.$refs.main.blur();
            this.box = true;
        },

        handleClose() {
            this.box = false;
            this.$emit("blur", { value: this.value });
        },
        //显示信息框
        showPosition(item) {
            const { marker, winHtml, name, address, longitude, latitude } = item;
            const markerInfoWin = new window.T.InfoWindow(winHtml, { autoPan: true });
            this.map.panTo(new window.T.LngLat(longitude, latitude), 17);
            marker.openInfoWindow(markerInfoWin);
            this.isSelect = true;
            this.address = address;
            this.poi = { address: name, longitude, latitude };
        },
        //关键字输入提示词条
        querySearch(queryString) {
            if (this.isSelect) {
                this.isSelect = false;
                return;
            }
            if (queryString) {
                this.fetching = true;
                this.localsearch.search(queryString, 4);
            } else {
                this.visibleSuggest = false;
            }
        },
        handleSearch() {
            // 清除上次标点结果
            this.map.clearOverLays();
            this.visibleSuggest = false;
            this.localsearch.searchInBounds(this.address, this.bounds);
        },
        handleSelectSug(name) {
            this.visibleSuggest = false;
            this.isSelect = true;
            this.address = name;
            this.handleSearch();
        },
        //解析建议词信息
        suggests(obj) {
            if (obj) {
                const _suggestArr = [];
                for (let i = 0; i < obj.length; i++) {
                const { name, address } = obj[i];
                const nameArr = name
                    .replaceAll(this.address, `$${this.address}$`)
                    .split("$");
                let nameStr = "";
                nameArr.forEach((str) => {
                    nameStr +=
                    str === this.address
                        ? `<span style="color: #3385ff;">${str}</span>`
                        : str;
                });

                _suggestArr.push({ name, nameStr, address });
                }
                //显示地图的最佳级别
                this.suggestArr = _suggestArr;
                this.visibleSuggest = true;
            }
        },
        //解析点数据结果
        pois(obj) {
            if (obj) {
                //坐标数组，设置最佳比例尺时会用到
                const zoomArr = [];
                const _resultArr = [];
                for (let i = 0; i < obj.length; i++) {
                const { name, address, phone, lonlat } = obj[i];
                const [longitude, latitude] = lonlat.split(","); //坐标
                const lnglat = new window.T.LngLat(longitude, latitude);
                const winHtml = "名称:" + name + "<br/>地址:" + address;

                //创建标注对象
                const marker = new window.T.Marker(lnglat);
                //地图上添加标注点
                this.map.addOverLay(marker);
                //注册标注点的点击事件
                let markerInfoWin = new window.T.InfoWindow(winHtml, {
                    autoPan: true,
                });
                marker.addEventListener("click", () => {
                    marker.openInfoWindow(markerInfoWin);
                });

                zoomArr.push(lnglat);
                _resultArr.push({
                    name,
                    address,
                    phone,
                    marker,
                    winHtml,
                    longitude,
                    latitude,
                });
                }
                //显示地图的最佳级别
                this.resultArr = _resultArr;
                this.visibleResult = true;
                this.map.setViewport(zoomArr);
            }
        },
        MapClick(e) {
            this.map.clearOverLays();
            const { lng: longitude, lat: latitude } = e.lnglat;
            //创建标注对象
            const marker = window.T && new window.T.Marker(new window.T.LngLat(longitude, latitude));

            //向地图上添加标注
            this.map.addOverLay(marker);
            this.geocode.getLocation(e.lnglat, (result) => {
                if (result.getStatus() == 0) {
                    const { county_code } = result.getAddressComponent().addressComponent;
                    const address = result.getAddress();
                    const county = county_code.slice(3);
                    this.isSelect = true;
                    this.address = address;
                    this.poi = { address, longitude, latitude, county };
                }
            });
        },
        init() {
            MapLoader().then(
                (T) => {
                    console.log("地图加载成功", T);
                    const { option: { config: conf } } = this.$attrs
                    if (!conf) return
                    const { VUE_APP_MAP_BOUNDS } = conf
                    //地理边界 区域内的左上和右下两点经纬度
                    //嘉兴 四角点坐标：120.291089,31.032404,121.335741,30.266023999999998
                    //平湖 四角点坐标：120.946321,30.859326999999997,121.335741,30.494577
                    this.bounds = new T.LngLatBounds(
                        new T.LngLat(...VUE_APP_MAP_BOUNDS[0]),
                        new T.LngLat(...VUE_APP_MAP_BOUNDS[1])
                    );

                    //初始化地图对象
                    this.map = new T.Map("map__container");
                    //创建对象
                    this.geocode = new T.Geocoder();
                    this.map.addEventListener("click", this.MapClick);
                    //设置显示地图的中心点和级别
                    const { longitude, latitude } = this.value || {};
                    const center = longitude
                        ? [longitude, latitude]
                        : [121.01106, 30.67934];
                    this.map.centerAndZoom(new T.LngLat(...center), this.value ? 16 : 13);
                    const config = {
                        pageCapacity: 10, //每页显示的数量
                        onSearchComplete: (result) => {
                        this.fetching = false;
                        //接收数据的回调函数
                        console.log("result>>>>>", result, result.getResultType());
                        //解析点数据结果
                        result.getResultType() === "4"
                            ? this.suggests(result.getSuggests())
                            : this.pois(result.getPois());
                        },
                    };
                    //创建搜索对象
                    this.localsearch = new T.LocalSearch(this.map, config);

                    //创建标注对象
                    const marker = new T.Marker(new T.LngLat(longitude, latitude));
                    //向地图上添加标注
                    this.map.addOverLay(marker);
                },
                (e) => {
                console.log("地图加载失败", e);
                }
            );
        },
    },
};
</script>
<style scoped>
::v-deep .amap-marker-img {
    width: 25px !important;
    height: 34px !important;
}
::v-deep .input-map-marker {
    position: absolute !important;
    top: -20px !important;
    right: -118px !important;
    color: #fff !important;
    padding: 4px 10px !important;
    -webkit-box-shadow: 1px 1px 1px rgba(10, 10, 10, 0.2);
    box-shadow: 1px 1px 1px rgba(10, 10, 10, 0.2);
    white-space: nowrap;
    font-size: 12px;
    background-color: #25a5f7 !important;
    border-radius: 3px;
    }
.input-map-content-container {
    width: 100%;
    height: 450px;
}
.input-map-content-result {
    position: absolute;
    top: 38px;
    right: 0;
    width: 250px;
    height: 450px;
    overflow-y: auto;

    border: 1px solid #ebedf0;
    border-radius: 2px;
    padding: 5px 10px 2px;
    background-color: #fff;
    z-index: 999;
}
.poibox {
    border-bottom: 1px solid #e8e8e8;
    cursor: pointer;
    padding: 10px 5px;
    position: relative;
    min-height: 35px;
}
.amap_lib_placeSearch_pic {
    width: 46px;
    height: 46px;
    float: left;
    margin: 4px 10px 0 0;
}
.poibox .poi-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.site-icon {
    margin-right: 5px;
    position: relative;
    top: -4px;
}
.poibox .poi-title .poi-name {
    max-width: 198px;
    display: inline-block;
}
.poibox .poi-info {
    word-break: break-all;
    margin: 0;
    overflow: hidden;
}
.poibox .poi-info p {
    color: #999;
    font-family: Tahoma;
    line-height: 20px;
    margin-bottom: 0;
}
.amap-ellipsis {
    max-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.name {
    text-overflow: ellipsis;
    overflow: hidden;
}
.addr {
    font-size: 12px;
    color: #b4b4b4;
}

.Suggest_suggests__E1VWl {
    background: #fff;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    border-top: 0;
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
        0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    left: 0;
    position: absolute;
    top: 42px;
    width: 100%;
    z-index: 1000;
}
.Suggest_liItem__UATyw {
    line-height: 32px;
    list-style: none;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis;
    transition: background 0.3s;
    white-space: nowrap;
}
.Suggest_liItem__UATyw:hover,
.poibox:hover {
    background: #f2f2f2;
    cursor: pointer;
}
.Suggest_suggests__E1VWl .anticon {
    color: #b8b8b8;
    margin-right: 5px;
}
.Suggest_name__d\+lUa {
    font-size: 13px;
}
.Suggest_keyword {
    color: #3385ff;
}
.Suggest_address__e0ul6 {
    color: #b8b8b8;
    font-size: 12px;
    margin-left: 12px;
}

.input-map-content-input {
    margin-bottom: 10px;
}

::v-deep .el-dialog__headerbtn {
    z-index: 999;
}
</style>